import {
  Accordion,
  ActionIcon,
  Anchor,
  Button,
  Chip,
  Divider,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import {
  formatAnswer,
  getProspectBio,
  parseProspectDatafields,
} from "../../../utils";
import { parseDate } from "../../../../../../functions/dates";
import {
  IconBrandLinkedin,
  IconSpeakerphone,
  IconX,
} from "@tabler/icons-react";
import { useMemo, useState } from "react";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import PositiveChanger from "../../actions/PositiveChanger";
import { Link } from "react-router-dom";
import AnswerDirectLink from "../../answers/AnswerDirectLink";
import EmailStatus from "../Right/answers/EmailStatus";
import EmailPreviewPrm from "../../../../../../components/View/EmailPreviewPrm";
import AnswerSenderMobile from "./AnswerSenderMobile";
import AnswerSenderLinkedinMobile from "./AnswerSenderLinkedinMobile";
import MessageAttachments from "../Right/answers/email/MessageAttachments";

const MoreActions = ({ item, current, setCurrent, container, progInfo }) => {
  if (progInfo || item?.reply)
    return (
      <Group align="center" gap={"xs"} wrap="nowrap" miw={64}>
        {progInfo && (
          <Tooltip label="Voir la campagne dans Statistiques">
            <ActionIcon
              component={Link}
              to={`/statistics/campaigns?highlight=${progInfo?.programmation_id}`}
              target="_blank"
              variant="subtle"
              opacity={0.75}
              ml={"auto"}
            >
              <IconSpeakerphone size={18} />
            </ActionIcon>
          </Tooltip>
        )}

        {item?.reply && (
          <PositiveChanger
            isAnswer
            containerId={current?.custom_status || current?.status}
            is_positive={item?.is_positive_reply}
            itemId={item?.id}
            prospectId={current?.id}
            reply_type={item?.type}
            actualProspect={current}
            setActualProspect={setCurrent}
            container={container}
          />
        )}
      </Group>
    );
  return "";
};

const TabAnswersItemMobile = ({
  index,
  item,
  type,
  about,
  current,
  setCurrent,
  container,
  setLoading,
  isLast,
  defaultLinkedinSender,
  hideCampaign,
  isOnly,
  lastLinkedinReply,
  onAnswerSent,
}) => {
  const [replying, setReplying] = useState(false);
  const lang = useLanguage((s) => s.language);

  const [opened, setOpened] = useState(isOnly ? "r" : null);
  const [modelSubject, setModelSubject] = useState(null);

  const date = new Date(item.date).toLocaleString(
    lang.id === "FRA" ? "fr-FR" : "en-EN",
    {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }
  );

  const progInfo = useMemo(() => {
    if (item.workflow_programmation_id) {
      let p = current?.programmations?.find(
        (x) => x.programmation_id === item.workflow_programmation_id
      );
      return p || null;
    } else {
      return current?.programmations?.find((x) => x.programmation_id === null);
    }
  }, [current?.programmations, item.workflow_programmation_id]);

  const referencedEvents = useMemo(() => {
    const events =
      item?.event === "email_sent"
        ? current.history?.filter(
          (x) =>
            x?.workflow_step_id === item.workflow_step_id &&
            x?.workflow_programmation_id === item.workflow_programmation_id
        )
        : current.history?.filter((x) => x?.reference_event_id === item.id) ||
        [];

    return {
      opens: events?.filter?.((x) => x.event === "email_open") || [],
      clicks: events?.filter?.((x) => x.event === "link_click") || [],
    };
  }, [current.history, item]);

  return type === "email" || item?.event === "email_sent" ? (
    <Accordion
      variant="contained"
      mb={isLast ? 0 : 16}
      bg={"#fff"}
      defaultValue={opened}
      onChange={setOpened}
    >
      <Accordion.Item value="r">
        <Accordion.Control>
          <Stack gap={"xs"} pt={4} pb={4} pr={32}>
            <Group wrap="nowrap">
              {(item?.history_type === "sent" ||
                item?.event === "email_sent") && (
                  <Chip checked variant="light" mr={"md"} size="xs">
                    {lang.prm.answer_sent}{" "}
                    {!item?.workflow_programmation_id && !item?.workflow_step_id
                      ? lang.leads.manual
                      : ""}
                    {item?.event === "email_sent" ? lang.prm.campaign : ""}
                  </Chip>
                )}
              <EmailStatus
                opens={referencedEvents?.opens}
                clicks={referencedEvents?.clicks}
                isMobile
              />

              {item?.history_type !== "sent" &&
                item?.event !== "email_sent" && (
                  <PositiveChanger
                    isAnswer
                    containerId={current?.custom_status || current?.status}
                    is_positive={item?.is_positive_reply}
                    itemId={item?.id}
                    prospectId={current?.id}
                    reply_type={item?.type}
                    actualProspect={current}
                    setActualProspect={setCurrent}
                    container={container}
                    pos="static"
                  />
                )}

              {item?.direct_link && (
                <AnswerDirectLink link={item.direct_link} isLinkedin={false} />
              )}
            </Group>
            <Text c={"gray"} size="sm">
              {date.charAt(0).toUpperCase() + date.slice(1)}
            </Text>
          </Stack>
        </Accordion.Control>

        <Accordion.Panel>
          <Paper
            component={Stack}
            radius={"md"}
            pos={"relative"}
            gap={0}
            // h={"100%"}
            style={{
              borderColor:
                item?.history_type === "sent"
                  ? "var(--mantine-color-primary-4)"
                  : undefined,
            }}
            mb={16}
            bg={"#fff"}
          >
            {item?.reply || item?.message ? (
              <iframe
                title={item.date}
                id="iFrame1"
                srcDoc={formatAnswer(item?.reply || item?.message)}
                style={{
                  width: replying ? "calc(100% - 50px)" : "100%",
                  border: "none",
                  borderLeft: replying ? "1px solid #00000016" : "none",
                  marginLeft: replying ? 42 : 0,
                  paddingLeft: replying ? 8 : 0,
                  height: "100%",
                  minHeight: 360,
                }}
              // sandbox=""
              />
            ) : (
              <EmailPreviewPrm
                opened={opened}
                step_id={item.workflow_step_id}
                prog_id={item.workflow_programmation_id}
                onModelFound={(model) => setModelSubject(model.subject)}
              />
            )}

            <MessageAttachments item={item} isMobile />

            <Divider mb={8} opacity={0.5} />

            <AnswerSenderMobile
              prospect={current}
              about={about}
              item={item}
              setAnswering={setReplying}
              setProspectLoading={setLoading}
              onAnswerSent={onAnswerSent}
              prog={progInfo}
              modelSubject={modelSubject}
              title={
                <>
                  {lang.prm.answer}:{" "}
                  <b>
                    {about?.firstName || " - "} {about.lastName || " - "} ({" "}
                    {about?.email} )
                  </b>
                </>
              }
            />
          </Paper>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  ) : (
    <Stack gap={6} className="hover-source" mb={8}>
      <Group
        wrap="nowrap"
        ml={item?.history_type === "reply" ? 0 : "auto"}
        mr={item?.history_type === "reply" ? 72 : 0}
      >
        {item?.message && <MoreActions type={type} />}
        <Paper
          withBorder
          bg={
            item?.message
              ? "var(--mantine-primary-color-1)"
              : "var(--mantine-color-gray-1)"
          }
          radius={"md"}
          p={"sm"}
          py={"xs"}
        >
          {item?.reply || item?.message}

          <MessageAttachments item={item} isMobile isLinkedin />
        </Paper>
        {/* {item?.reply && (
          <MoreActions
            item={item}
            container={container}
            current={current}
            setCurrent={setCurrent}
            progInfo={progInfo}
          />
        )} */}
      </Group>
      <Text
        ta={item?.history_type === "reply" ? "left" : "right"}
        size="xs"
        c={"dimmed"}
        w={"100%"}
        ml={item?.history_type === "reply" ? 42 : 0}
      >
        {parseDate(item.date, false)}
      </Text>

      {isLast && (
        <AnswerSenderLinkedinMobile
          prospect={current}
          about={getProspectBio(parseProspectDatafields(current))}
          item={item}
          lastLinkedinReply={lastLinkedinReply}
          setAnswering={setReplying}
          setProspectLoading={setLoading}
          defaultSender={defaultLinkedinSender}
          title={
            <>
              {lang.prm.answer}:{" "}
              <b>
                {about?.firstName || " - "} {about.lastName || " - "}
              </b>
            </>
          }
        />
      )}
    </Stack>
  );
};

export default TabAnswersItemMobile;
